/**
 * Collection Cards Slider – Swiper Init
 * Works with multiple sections
 * Shopify editor safe
 * NO Liquid used here
 */

(function () {
  /**
   * Init single swiper instance
   */
  function initCollectionSwiper(swiperEl) {
    if (!swiperEl || typeof Swiper === 'undefined') return;

    // Prevent double init
    if (swiperEl.classList.contains('swiper-initialized')) return;

    const sectionId = swiperEl.dataset.sectionId;
    const enableLoop = swiperEl.dataset.loop === 'true';
    const slidesDesktop = parseInt(swiperEl.dataset.slidesDesktop || 5, 10);
    const slidesTablet = parseInt(swiperEl.dataset.slidesTablet || 3, 10);
    const autoplayEnabled = swiperEl.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(swiperEl.dataset.delay || 3000, 10);

    new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      observer: true,
      observeParents: true,

      navigation: {
        nextEl: `.swiper-button-next-${sectionId}`,
        prevEl: `.swiper-button-prev-${sectionId}`,
      },

      loop: enableLoop,
      loopedSlides: slidesDesktop,
      loopAdditionalSlides: 5,

      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,

      breakpoints: {
        480: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        750: {
          slidesPerView: slidesTablet,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: 24,
        },
      },
    });
  }

  /**
   * Init all sliders on page
   */
  function initAllCollectionSwipers(scope) {
    const container = scope || document;
    container
      .querySelectorAll('.collection-cards-swiper')
      .forEach(initCollectionSwiper);
  }

  /**
   * Normal page load
   */
  document.addEventListener('DOMContentLoaded', function () {
    initAllCollectionSwipers(document);
  });

  /**
   * Shopify Theme Editor – section reload
   */
  document.addEventListener('shopify:section:load', function (event) {
    initAllCollectionSwipers(event.target);
  });
})();
